module.exports = __webpack_public_path__ + "img/couples-051.751bde01.jpg";